<dgx-search-landing-page
  [persistedFilterParam]="filterParam"
  [filterIdsToIgnore]="filterIdsToIgnore"
  [numberOfFilterSkeletonColumns]="3"
  [title]="title"
  [isLoading]="!hasError && !(data | async)"
  [hasError]="hasError"
  [results]="(data | async)?.results"
  [filters]="(data | async)?.filters"
  [totalNumResults]="(data | async)?.total"
  [searchOrigin]="searchOrigin"
  [customTrackerProperties]="customTrackerProperties"
  [showDefaultSuggestions]="true"
  [hasNoResultsFullPage]="true"
  [usesGlobalSearchApi]="true"
  [showSortByWithInitialValue]="'recent'"
  (searchTerm)="search($event)"
>
  <ul id="results" class="grid">
    <li
      *ngFor="let item of (data | async)?.results; index as i"
      class="grid__col-xs-6 grid__col-sm-4 grid__col-md-3"
      data-dgat="search-providers-view-716"
    >
      <dgx-tile-launcher
        *ngIf="(data | async)?.results"
        [actionContext]="item.model"
        [item]="item.model"
        [tileIndex]="i"
        [expandCard]="(indexesOfExpandedCards$ | async)?.includes(i)"
      ></dgx-tile-launcher>
    </li>
  </ul>

  <dgx-search-provider-no-results
    id="noResultsFullPage"
    class="block guts-m-t-10"
    [providerName]="title"
  ></dgx-search-provider-no-results>
</dgx-search-landing-page>
